'use strict';

import store from "@/store"
import moment from "moment/moment"
import numeral from 'numeral';

import blockLib from '@/lib/block'
import categoryLib from "@/lib/category"
import exerciseLib from '@/lib/exercise'
import panelHandler from "@/lib/panelHandler"
import participantLib from '@/lib/participant'
import rankingLib from '@/lib/ranking'
import rounds from "@/lib/rounds"
import sessionLib from '@/lib/session'

import concat from 'lodash/concat'
import sortBy from "lodash/sortBy"

export default {
  prepareData: function (eventDiscipline, sessions) {
    return new Promise((resolve) => {
      store.dispatch('panels.getByEventDiscipline', {eventDisciplineId: eventDiscipline.id}).then(() => {
        const panels = store.state.panels.items
        console.log(sessions, panels)

        const event = store.state.events.current
        const discipline = store.state.eventDiscipline.discipline

        const data = []

        // assemble list of categories with their respective competitionIds
        const catSets = []
        sessions.forEach(session => {
          session.categories.forEach(sc => {
            const category = store.state.categories.items.find(i => i.id === sc.categoryId)
            let competitionId = eventDiscipline.accessId
            if (category.competitionId) {
              competitionId = category.competitionId
            }
            let catSet = catSets.find(i => i.id === competitionId)
            if (! catSet) {
              catSet = {
                id: competitionId,
                categories: [],
                rounds: []
              }
              catSets.push(catSet)
            }

            const cat = catSet.categories.find(i => i.id === category.id)
            if (! cat && category.accessId) {
              catSet.categories.push(category)
            }
            const round = rounds.getRound(session.roundIndex)
            const setRound = catSet.rounds.find(i => i.index === round.index)
            if (!setRound) {
              catSet.rounds.push(round)
            }
          })
        })
        console.log(catSets)

        catSets.forEach(catSet => {
          catSet.categories = sortBy(catSet.categories, 'index')
          catSet.rounds = sortBy(catSet.rounds, 'index')

          const setData = {
            eventId: catSet.id,
            title: eventDiscipline.name,
            venue: event.venue,
            country: event.countryId.substring(8,11).toUpperCase(),
            startDate: moment(event.date_from.substring(0, 10), 'YYYY/MM/DD').format('YYYY-MM-DD'),
            endDate: moment(event.date_to.substring(0, 10), 'YYYY/MM/DD').format('YYYY-MM-DD'),
            timestamp: moment(Date.now()).format('DD/MM/YYYY - HH:mm'),
            discipline: discipline.nameShort,
            phases: [],
          }

          const rankings = []
          const teamRankings = []

          catSet.categories.forEach(category => {
            catSet.rounds.forEach(round => {
              const catRound = category.rounds.find(i => i.roundIndex === round.index)
              console.log('add phases', category.name, round.name, catRound)
              if (! catRound) return

              // find sessions that apply
              let crSessions = sessions.filter(s => s.roundIndex === round.index && s.categories.find(sc => sc.categoryId === category.id))
              crSessions = sortBy(crSessions, 'index')

              // find exerciseTypes
              const exerciseTypes = categoryLib.getCategoryExerciseTypes(category.id, round.index)
              console.log(exerciseTypes)

              exerciseTypes.forEach(exerciseType => {
                console.log('add phase', category.name, round.name, exerciseType)
                // select session and panel
                let panel = null
                let rotationType = null
                const session = crSessions.find(s => {
                  const sc = s.categories.find(sc => sc.categoryId === category.id)
                  rotationType = sessionLib.getSessionRotationTypeFull(s)

                  switch(rotationType) {
                    case 'mixed': {
                      const sce = sc.exercises.find(sce => sce.exerciseTypeId === exerciseType)
                      if (sce?.set > 0) {
                        panel = panels.find(p => p.sessionId === s.id && p.set === sce.set)
                      }
                      return sce?.set > 0
                    }
                    case 'rotation': {
                      panel = panels.find(p => p.sessionId === s.id && p.set === sc.set && p.exerciseTypeId === exerciseType)
                      return panel
                    }
                  }
                })

                console.log(session, panel, exerciseType)

                if (! panel) {
                  return
                }

                const ep = panelHandler.exportPanel(panel)
                ep.positions.forEach(j => {
                  if (j.jep?.panel) {
                    // console.log(j.jep.panel, j.jep.positionPrefix, j.subIndex)
                    j.jep.position = j.jep.positionPrefix
                    if (! j.jep.noIndex) {
                      j.jep.position += j.subIndex
                    }
                    // console.log(j.jep.position)
                  }
                })
                console.log('panel', exerciseType)
                console.log(ep)

                const eventRanking =
                  rankingLib.getRanking(category.id, session.roundIndex, 'EVENTS', 'regular', null, exerciseType)
                if (! eventRanking) return

                const units = []

                // add subdivision
                let unitIndex = 0
                for (let r = 0; r < session.rotations; r++) {
                  const blockOrder = blockLib.getPanelOrder(panel, r)
                  console.log('blockOrder', r, exerciseType)
                  console.log(blockOrder)

                  blockOrder.forEach(bo => {
                    let blockParticipations = bo.participations
                    if (rotationType === 'mixed') {
                      blockParticipations = blockParticipations.filter(bp => bp.exerciseTypeId === exerciseType)
                    }

                    blockParticipations.forEach(bp => {
                      const participation = participantLib.getParticipation(bp.participationId)
                      if (participation.categoryId !== category.id) return
                      const partRound = participation.rounds.find(r => r.roundIndex === round.index)

                      unitIndex++
                      const participant = participantLib.getParticipant(participation)
                      const club = participantLib.getClub(participant)

                      const rankingItem = eventRanking.items.find(i => i.participationId === bp.participationId)

                      let groupNumber = null
                      let figId = null
                      let lastName = null
                      let firstName = null
                      const nf = club.countryId.substring(8, 11).toUpperCase()
                      let groupMembers = null

                      if (category.participantType === 'group') {
                        groupNumber = 1
                        let members = participantLib.getMembers(participant, 'group')

                        if (partRound.exerciseGroupMembers) {
                          members = members.filter(m => partRound.exerciseGroupMembers[exerciseType].includes(m.id))
                        }
                        groupMembers = members.map(m => {
                          return {
                            figId: m.accessId,
                            lastName: m.lastName,
                            firstName: m.firstname,
                          }
                        })
                      }
                      else { // individual
                        figId = participant.accessId
                        lastName = participant.lastName
                        firstName = participant.firstname
                      }

                      const unit = {
                        groupNumber,
                        figId,
                        lastName,
                        firstName,
                        nf,
                        groupMembers,
                      }

                      const exercise = exerciseLib.getExercise(participation.id, session.roundIndex, exerciseType)
                      console.log(exercise)

                      let addUnit = false
                      if (exercise) {
                        switch (discipline.nameShort) {
                          case 'RG':
                            addUnit = this.prepareResultRG(unit, exercise, rankingItem, ep, unitIndex)
                            break
                          case 'MAG':
                            addUnit = this.prepareResultMAG(unit, exercise, rankingItem, ep, unitIndex)
                            break
                        }
                      }

                      if (addUnit) {
                        units.push(unit)
                      }
                    })
                  })
                }

                const startTime = session.timeTable.find(i => i.time && i.key === 'competition')
                const subdivisions = [
                  {
                    number: 1,
                    startTime: moment(session.date).format('YYYY-MM-DD') + ' ' + startTime.time,
                    units,
                  }
                ]

                const exerciseTypeObj = store.state.eventDiscipline.exerciseTypes.find(et => et.id === exerciseType)

                const phase = {
                  phaseLabel: round.index === 0 ? 'Q' : 'AF',
                  apparatus: exerciseTypeObj.figLabel,
                  category: category.accessId,
                  judges: ep.positions,
                  subdivisions,
                }

                setData.phases.push(phase)
              })

              // add AA ranking information
              if (round.index === 0) {
                // add AA ranking if applicable
                const aaRanking =
                  rankingLib.getRanking(category.id, round.index, 'AA', 'regular')

                if (aaRanking) {
                  if (category.participantType === 'group') {
                    const teams = aaRanking.items.map(ri => {
                      const participation = participantLib.getParticipation(ri.participationId)
                      const participant = participantLib.getParticipant(participation)
                      const club = participantLib.getClub(participant)

                      const irm = null
                      const score = ri.result
                      const ranking = ri.ranking
                      const nf = club.countryId.substring(8, 11).toUpperCase()

                      const units = ri.exercises.map(e => {
                        const exerciseType = store.state.eventDiscipline.exerciseTypes.find(et => et.id === e.exerciseTypeId)
                        return {
                          groupNumber: 1,
                          unitApparatus: exerciseType.figLabel,
                        }
                      })

                      return {
                        nf,
                        irm,
                        score,
                        ranking,
                        units,
                      }
                    })

                    teamRankings.push({
                      phase: 'TR',
                      teamApparatus: 'GRP',
                      ageCategory: category.accessId,
                      teams,
                    })
                  }
                  else {
                    const units = aaRanking.items.map(ri => {
                      const participation = participantLib.getParticipation(ri.participationId)
                      const participant = participantLib.getParticipant(participation)
                      const club = participantLib.getClub(participant)

                      let groupNumber = null
                      let figId = null
                      let nf = null
                      const irm = null
                      const score = ri.result
                      const ranking = ri.ranking

                      if (category.participantType === 'group') {
                        groupNumber = 1
                        nf = club.countryId.substring(8, 11).toUpperCase()
                      } else { // individual
                        figId = participant.accessId
                      }

                      return {
                        groupNumber,
                        figId,
                        nf,
                        irm,
                        score,
                        ranking,
                      }
                    })

                    rankings.push({
                      phase: 'Q',
                      name: 'AllAround',
                      ageCategory: category.accessId,
                      units,
                    })
                  }
                }

                const teamRanking =
                  rankingLib.getRanking(category.id, round.index, 'TEAM-AA', 'regular')

                if (teamRanking) {
                  const teams = teamRanking.items.map(ri => {
                    const teamPart = participantLib.getParticipation(ri.participationId)
                    const team = participantLib.getParticipant(teamPart)
                    const club = participantLib.getClub(team)



                    let nf = club.countryId.substring(8, 11).toUpperCase()
                    const irm = null
                    const score = ri.result
                    const ranking = ri.ranking

                    const members = participantLib.getMembers(team, 'team').map(m => ({
                      figId: m.accessId,
                    }))
                    const groups = []
                    participantLib.getGroups(team).forEach(() => {
                      groups.push({
                        groupNumber: 1,
                        unitApparatus: '5HOOP',
                      })
                      groups.push({
                        groupNumber: 1,
                        unitApparatus: '5CLUB',
                      })
                    })

                    return {
                      units: concat(members, groups),
                      nf,
                      irm,
                      score,
                      ranking,
                    }
                  })

                  teamRankings.push({
                    phase: 'TR',
                    teamApparatus: 'TEAMAA',
                    ageCategory: category.accessId,
                    teams,
                  })
                }
              }
            })
          })

          if (rankings.length) {
            setData.rankings = rankings
          }
          if (teamRankings.length) {
            setData.teamRankings = teamRankings
          }

          data.push(setData)
        })

        resolve(data)
      })
    })
  },

  prepareResultRG: function(unit, exercise, rankingItem, panel, order) {
    if (! exercise && ! rankingItem) return false

    console.log('prepareResultRG', exercise, rankingItem, panel, order)
    unit.irm = rankingItem ? null : 'DNS'
    unit.score = rankingItem ? rankingItem.result : null
    unit.ranking = rankingItem ? rankingItem.ranking : null

    const scores= [
      {
        type: 'Exercise',
        value: this.getExerciseValue(exercise, 1, 'total', 'total', -1, -1)
      },
      {
        type: 'Exe',
        value: this.getExerciseValue(exercise, 1, 'execution', 'total', -1, -1)
      },
      {
        type: 'Art',
        value: this.getExerciseValue(exercise, 1, 'artistic', 'total', -1, -1)
      },
      {
        type: 'DiffB',
        value: this.getExerciseValue(exercise, 1, 'difficulty1', 'total', -1, -1)
      },
      {
        type: 'DiffA',
        value: this.getExerciseValue(exercise, 1, 'difficulty2', 'total', -1, -1)
      },
      {
        type: 'PenAll',
        value: this.getExerciseValue(exercise, 1, 'penalty', 'total', -1, -1)
      }
    ]

    // add marks
    const marks = []
    panel.positions.forEach(j => {
      if (! j.jep?.position) return
      let index = 0
      let element = j.type
      if (j.jep.panel === 'Exe' || j.jep.panel === 'Art') {
        index = -1
        element = 'total'
      }

      marks.push({
        position: j.jep.position,
        mark: this.getExerciseValue(exercise, 1, j.type, element, j.positionNr, index)
      })
    })

    unit.exercises = [{
      number: 1,
      order,
      scores,
      marks,
    }]

    return true
  },

  prepareResultMAG: function(unit, exercise, rankingItem, panel, order) {
    console.log('prepareResultMAg', exercise, rankingItem, panel, order)

    unit.irm = rankingItem ? null : 'DNS'
    unit.score = rankingItem ? rankingItem.result : null
    unit.ranking = rankingItem ? rankingItem.ranking : null

    if (exercise.status === 'finished') {
      if (exercise.passes < exercise.config.passes) {
        unit.irm = 'DNF'
      }
    }

    const exercises = []

    for (let i = 0; i < exercise.passes; i++) {
      const leg = i+1
      const scores= [
        {
          type: 'Exercise',
          value: this.getExerciseValue(exercise, 1, 'total', 'total', -1, -1)
        },
        {
          type: 'Exe',
          value: this.getExerciseValue(exercise, 1, 'execution', 'total', -1, -1)
        },
        {
          type: 'Diff',
          value: this.getExerciseValue(exercise, 1, 'difficulty', 'difficulty', 0, 0)
        },
        {
          type: 'PenAll',
          value: this.getExerciseValue(exercise, 1, 'penalty', 'total', -1, -1)
        },
      ]

      if (exercise.config.stickLanding) {
        scores.push({
          type: 'StickBonus',
          value: this.getExerciseValue(exercise, 1, 'bonus', 'stickLanding', 0, 0)
        })
      }

      // add marks
      const marks = []

      panel.positions.forEach(j => {
        if (! j.jep.position) return
        let position = j.positionNr
        let index = 0
        let type = j.type
        let element = j.type

        switch (j.jep.panel) {
          case 'Exe':
            index = -1
            element = 'total'
            break
          case 'Diff':
            type = 'difficulty'
            index = 0
            element = 'difficulty'
            position = 0
            break
          default:
            return
        }
        marks.push({
          position: j.jep.position,
          mark: this.getExerciseValue(exercise, leg, type, element, position, index)
        })
      })

      exercises.push({
        number: leg,
        order,
        scores,
        marks,
      })
    }

    unit.exercises = exercises
    return true
  },

  getExerciseValue: function(exercise, leg, group, element, position, index) {
    console.log('get value', group, element, position, index)
    const value = exercise.scoreValues.find(v => {
      return (v.leg === leg && v.group === group
        && v.element === element
        && v.position === position
        && v.index === index)
    })
    if (value) {
      return numeral(value.publicValue).format('0.000')
    }
    return '0.000'
  },
}
